export default [
  {
    id: 1,
    title: 'ResumeX',
    score: Math.ceil(Math.random() * 100),
    description: 'xxX Duis rhoncus, nibh in venenatis suscipit, nisl ligula luctus odio, quis finibus lectus nibh in justo. Cras non commodo purus. Cras nisi nisl, pretium vitae rutrum vel, varius non arcu. Cras sed placerat nisi, ac lacinia nulla. Aenean porta justo imperdiet fringilla pharetra.',
    scores: [
      {
        id: 1,
        title: 'English Grammar',
        score: Math.ceil(Math.random() * 100),
        description: 'Duis rhoncus, nibh in venenatis suscipit, nisl ligula luctus odio, quis finibus lectus nibh in justo. Cras non commodo purus. Cras nisi nisl, pretium vitae rutrum vel, varius non arcu. Cras sed placerat nisi, ac lacinia nulla. Aenean porta justo imperdiet fringilla pharetra.',
      },
      {
        id: 2,
        title: 'Formatting',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 3,
        title: 'Action and Outcome Oriented',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 4,
        title: 'Industry Tailoring',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 5,
        title: 'Relevant Content and Skills',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 6,
        title: 'English Grammar',
        score: Math.ceil(Math.random() * 100),
        description: 'Duis rhoncus, nibh in venenatis suscipit, nisl ligula luctus odio, quis finibus lectus nibh in justo. Cras non commodo purus. Cras nisi nisl, pretium vitae rutrum vel, varius non arcu. Cras sed placerat nisi, ac lacinia nulla. Aenean porta justo imperdiet fringilla pharetra.',
      },
      {
        id: 7,
        title: 'Formatting',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 8,
        title: 'Action and Outcome Oriented',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 9,
        title: 'Industry Tailoring',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 10,
        title: 'Relevant Content and Skills',
        score: Math.ceil(Math.random() * 100),
      },
    ]
  },
  {
    id: 2,
    title: 'Cover Letter',
    score: Math.ceil(Math.random() * 100),
    description: 'Duis rhoncus, nibh in venenatis suscipit, nisl ligula luctus odio, quis finibus lectus nibh in justo. Cras non commodo purus. Cras nisi nisl, pretium vitae rutrum vel, varius non arcu. Cras sed placerat nisi, ac lacinia nulla. Aenean porta justo imperdiet fringilla pharetra.',
    scores: [
      {
        id: 11,
        title: 'English Grammar',
        score: Math.ceil(Math.random() * 100),
        description: 'Duis rhoncus, nibh in venenatis suscipit, nisl ligula luctus odio, quis finibus lectus nibh in justo. Cras non commodo purus. Cras nisi nisl, pretium vitae rutrum vel, varius non arcu. Cras sed placerat nisi, ac lacinia nulla. Aenean porta justo imperdiet fringilla pharetra.',
      },
      {
        id: 12,
        title: 'Formatting',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 13,
        title: 'Action and Outcome Oriented',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 14,
        title: 'Industry Tailoring',
        score: Math.ceil(Math.random() * 100),
      },
      {
        id: 15,
        title: 'Relevant Content and Skills',
        score: Math.ceil(Math.random() * 100),
      },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/ScoreList/dummy-data.js